import styled from 'styled-components';

export const ScoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .review-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 3px 0;
  }

  .rating {
    min-width: 30px;
    font-size: 12px;
    color: #666;
  }

  .bar {
    flex: 1;
    display: flex;
    flex-direction: row-reverse;
    height: 6px;
    border-radius: 3px;
    overflow: hidden;
    background-color: #E5E5E5;
  }

  .empty-bar {
    flex: 1;
    background-color: #E5E5E5;
  }

  .filled-bar {
    height: 6px;
    background-color: #FFBE55;
  }

  .review-count {
    min-width: 30px;
    font-size: 11px;
    color: #999;
    text-align: right;
  }
`;
